module.exports = __webpack_public_path__ + "static/media/Story-Research-Photo 3.c845e534.jpg";